// 定义英文语言包对象
export default {
  bigScreen: {
    品河线锯数字化智能监控系统:
      "Intelligent Monitoring System of PinHe Wire Saw",
    在线设备数: "Online Devices",
    设备数: "Devices number",
    异常设备: "Faulty devices",
    正常设备: "Normal devices",
    切割统计: "Cutting Statistics",
    切割耗线量: "Cutting wire consumption",
    耗线量: "Wire consumption",
    切割荒料量: "Cutting stone number",
    荒料量: "stone number",
    切割平方数: "Cutting square",
    在线设备列表: "List of Online Devices",
    序号: "Number",
    客户名称: "Customer",
    型号: "Model",
    编号: "Serial Number",
    工作状态: "Working status",
    更新时间: "Update time",
    磊扬石材: "LeiYang Stone",
    汉艺石业: "HanYi Stone",
    澳文洲石业: "AoWenZhou Stone",
    百辰中宇石业: "BaiChenZhongYu Stone",
    开机: "Open",
    报警: "Warning",
    关机: "Close",
    实时切割视频: "Real-time monitoring video",
    实时监控视频: "Real-time monitoring video",
    暂无监控视频: "No available videos",
    暂无数据: "No data available",
    报警统计: "Warning Statistics",
    传感器故障: "Sensor fault",
    电机故障: "Motor fault",
    导轨故障: "Guide rail fault",
    轴箱故障: "Bearing box fault",
    断线: "Wire break",
    "湾流-G2034": "WanLiu-G2034",
    "飞流-G2034": "FeiLiu-G2034",
    单位: "Unit",
    万: "10K",
    个: "pcs",
    台: "",
    更多: "More",
    查看全部数据: "View all data",
    月: "Month",
    一月: "Jan",
    二月: "Feb",
    三月: "Mar",
    四月: "Apr",
    五月: "May",
    六月: "Jun",
    七月: "Jul",
    八月: "Aug",
    九月: "Sep",
    十月: "Oct",
    十一月: "Nov",
    十二月: "Dec",
    语种: "Language",
  },
  detailScreen: {
    切割时间统计: "Cutting Time Statistics",
    切割剩余时间: "Cutting Unfinished Time",
    切割开始时间: "Start time",
    预计结束时间: "Expected end time",
    完成率: "Completion rate",
    剩余时间: "Unfinished time",
    切割配方: "Cutting Recipe",
    更多数据: "More",
    当前步数: "Current step",
    进给位置: "Cutting position",
    送线长度: "Delivery wire length",
    进给速度: "Cutting velocity",
    线速度: "Wire velocity",
    回线长度: "Recycle wire length",
    轴曲线区域: "Curve Area",
    速度: "Velocity",
    扭矩: "Torque",
    电机温度: "Motor temperature",
    主轴箱温度: "Main bearing temperature",
    副轴箱温度: "Assistant bearing temperature",
    切割状态: "Cutting status",
    热机完成: "Preparation completed",
    当前切割配方: "Current cutting recipe",
    当前切割配方数据: "Current cutting recipe data",
    报警: "Warning",
    轴报警: "Bearing Warning",
    耗电量: "Power consumption",
    切割平方数: "Cutting square",
    左升降: "Left Lifting Axis",
    右升降: "Right Lifting Axis",
    主轴2: "Main Axis 2",
    主轴1: "Main Axis 1",
    主轴3: "Main Axis 3",
    主轴4: "Main Axis 4",
    左张力: "Left Tension Axis",
    右张力: "Right Tension Axis",
    左排线: "Left Wire Laying Axis",
    右排线: "Right Wire Laying Axis",
    左线轮: "Left Wire Axis",
    右线轮: "Right Wire Axis",
    正常: "Normal",
    异常: "Faulty",
    耗材管理: "Material Management",
    罗拉使用时间: "Roller using time",
    主轴箱使用时间: "Main bearing using time",
    副轴箱使用时间: "Assistant bearing using time",
    实时监控视频: "Real-time monitoring video",
    实时视频: "Real-time monitoring video",
    度: "°",
    详情: "Details",
    状态: "Status",
    故障代码: "Fault code",
    无: "None",
    运动: "Sport",
    静止: "Static",
    正在解除: "Releasing",
    停止: "Stop",
    正在开始: "Starting",
    准备就绪: "Ready",
    叠加: "Stack",
    运行: "Running",
    正在停止: "Stopping",
    正在急停: "Emergency Stopping",
    急停: "Emergency Stop",
    正在暂停: "Pausing",
    暂停: "Pause",
    解除暂停: "Resume",
    正在叠加: "Be stacking",
    解除叠加: "Remove Stack",
    正在复位: "Resetting",
    正在完成: "Completing",
    完成: "Complete",
    步骤: "Steps",
    设备树: "Devices tree",
    返回: "Back",
  },
};
